<div class="eforall-common-field form-floating">

	@let currentField = field();
	@let state = currentField.formField();
	@let validations = currentField.validations;

	<input class="form-control"
		[id]="randomId"
		[type]="'number'"
		[placeholder]="displayLabel()"
		[formField]="currentField.formField" />

	<label [for]="randomId" class="color-gray d-flex w-100">
		{{ displayLabel() }}
		@if (!validations || !validations.isRequired?.()) {
		<span class="ps-1">(optional)</span>
		}
	</label>

	@if (state.touched() && state.invalid()) {
	<div class="error-message" role="alert">
		@for (error of state.errors(); track error) {
		<div class="color-darkred text-end" style="font-size: 14px">{{ error.message }}</div>
		}
	</div>
	}
</div>